const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/roles.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/roles')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface Role {
  id: string;
  name: string;
  type: string;
  description: string | null;
  permissions: string[];
  isSystem: boolean;
  memberCount: number;
}
interface PermissionCategory {
  key: string;
  permissions: string[];
}

// force rebuild 1774089430